import _ from 'lodash'

const combineStrings = (list, seperator = ' ') => {
  if (!_.isArray(list)) throw Error('The list param is not an array.')
  const sanitizedList = _.filter(list, (item) => typeof item === 'string')
  return _.compact(sanitizedList).join(seperator).trim()
}

export default combineStrings
